"use client";

import { Card } from "@/components/ui/card";
import { motion } from "framer-motion";

interface LegalPageLayoutProps {
  children: React.ReactNode;
  title: string;
  description?: string;
}

const LegalPageLayout = ({ children, title, description }: LegalPageLayoutProps) => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl animate-in fade-in duration-500">
      <Card className="p-8 bg-background/60 backdrop-blur supports-[backdrop-filter]:bg-background/60">
        <div className="space-y-4">
          <h1 className="text-4xl font-bold mb-4">{title}</h1>
          {description && (
            <p className="text-muted-foreground mb-8">{description}</p>
          )}
          <div className="prose prose-lg dark:prose-invert max-w-none">
            {children}
          </div>
        </div>
      </Card>
    </div>
  );
};

export default LegalPageLayout;